/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* custom JS start */ 
$('.accordion-head').click(function() {
  // Check if the clicked header is already active
  if ($(this).hasClass('active')) {
    // If active, remove 'active' class and slide up the corresponding content
    $(this).removeClass('active');
    $(this).next('.accordion-content').slideUp(280);
  } else {
    // If not active, remove 'active' class from all headers
    $('.accordion-head').removeClass('active');
    // Slide up all contents
    $('.accordion-content').slideUp(280);
    // Add 'active' class to the clicked header
    $(this).addClass('active');
    // Slide down the content related to the clicked header
    $(this).next('.accordion-content').slideDown(280);
  }
});



$(document).ready(function(){
  $('.tab-link button').click(function(){
    $('.tab-link button').removeClass('active-tab');
    $(this).addClass('active-tab');
    var tagid = $(this).data('tag');
    $('.tab-content').removeClass('active-content').addClass('hide-content');
    $('#'+tagid).addClass('active-content').removeClass('hide-content');
    $(".product-slider-1, .product-slider-2, .product-slider-3, .product-slider-4, .product-slider-5").slick('refresh');
  });

      $(".product-slider-1, .product-slider-2, .product-slider-3, .product-slider-4, .product-slider-5").slick({
          infinite: false,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          arrows: true,
          dots: false,
          draggable: true,
          responsive: [
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows:true,
                  }
              },         
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows:true,
                  }
              }                
          ]
      });

  
});

// Show or hide the button based on scroll position
window.onscroll = function() {
    const scrollButton = document.querySelector('.scroll-to-top');
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
        scrollButton.style.display = 'block';
    } else {
        scrollButton.style.display = 'none';
    }
};

// Smooth scroll to top when the button is clicked
document.querySelector('.scroll-to-top').addEventListener('click', function(event) {
    event.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});


/* custom JS end */
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-item');

  // Set the first menu item as active on page load
  if (menuItems.length > 0) {
    menuItems[0].classList.add('active');
  }

  menuItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();

      // Remove 'active' class from all menu items
      menuItems.forEach(function(i) {
        i.classList.remove('active');
      });

      // Add 'active' class to the clicked item
      item.classList.add('active');

      // Smooth scroll to the target section
      const scrollToId = item.getAttribute('data-scroll-to');
      const scrollToElement = document.getElementById(scrollToId);

      if (scrollToElement) {
        scrollToElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var shareToggle = document.querySelector('.custom-share-toggle');
  var shareButtons = document.querySelector('.custom-share-buttons');

  // Function to show share buttons
  function showShareButtons() {
    shareButtons.style.display = 'block'; // Show share buttons
    shareToggle.style.display = 'none'; // Hide toggle button
  }

  // Function to hide share buttons
  function hideShareButtons() {
    shareButtons.style.display = 'none'; // Hide share buttons
    shareToggle.style.display = 'block'; // Show toggle button
  }

  // Event listener to show share buttons when toggle is clicked
  shareToggle.addEventListener('click', function(event) {
    event.preventDefault();
    showShareButtons();
  });

  // Event listener for document to check for outside clicks
  document.addEventListener('click', function(event) {
    var isClickInside = shareButtons.contains(event.target) || shareToggle.contains(event.target);

    if (!isClickInside) {
      hideShareButtons();
    }
  });
});

